import { formatPrice } from '@utils'

export const formatShippingPromotionDescription = (
  minShippingAmount: number,
  minShippingFee: number,
  currency: string | undefined,
) => {
  const nextShippingText = minShippingFee === 0
    ? '免運'
    : `運費 ${formatPrice(currency, minShippingFee)}`

  return minShippingAmount > 0
    ? `還差 ${formatPrice(currency, minShippingAmount)} ${nextShippingText}`
    : ''
}
